import { Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DeviceCommonService } from 'src/app/home/site-dashboard/device/device-common.service';
import { SitesService } from 'src/app/sites/sites.service';
import { shiftScheduleOptions, TruckSettingsStepValue, TruckUtilizationSettings, UtilizationSettingType } from '../site-utilization-settings.interface';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-truck-utilization-settings',
	templateUrl: './truck-utilization-settings.component.html',
	styleUrls: ['./truck-utilization-settings.component.css']
})

export class TruckUtilizationSettingsComponent implements OnInit, OnDestroy {
	truckUtilizationSettings: TruckUtilizationSettings = {
		min_daily_truck_operating_minutes: 30,
		min_truck_utilization: 20,
		min_truck_energy_utilization: 20,
		deep_in_use_end_voltage_limit: 1.9,
		num_of_deep_in_use_cycles: 5,
		low_in_use_end_voltage_limit: 1.8,
		num_of_low_in_use_cycles: 5,
		geofence_distance: 1000,
		shift_schedule: 8,
	};

	disableButton: boolean = false;
	siteId: number;
	selectedDays: number[] = [0, 1, 2, 3, 4]; // Days Monday TO Friday ==> checked By Default
	workingDays = this.commonService.workingDays;
	truckStepValues = TruckSettingsStepValue;
	subSite: Subscription = new Subscription();
	settingType: UtilizationSettingType = UtilizationSettingType.Truck;

	constructor(
		private route: ActivatedRoute,
		private commonService: CommonService,
		private siteService: SitesService,
		private elementRef: ElementRef,
		private render: Renderer2,
		private notificationService: NotificationMessageService,
		private translate: TranslateService,
		public deviceCommonService: DeviceCommonService,
	){}

	ngOnInit() {
		this.siteId = Number(this.route.parent.snapshot.params.siteId);
		this.subSite = this.siteService.siteUtilizationSettingsData.subscribe((data:any) => {			
			if (data.truck_utilization_settings && Object.keys(data.truck_utilization_settings).length) {
				this.truckUtilizationSettings = data.truck_utilization_settings;
				this.selectedDays = data.truck_utilization_working_days;
				return;
			}
		});
	}

	saveTruckUtilizationSettings() {
		let invalidInputs = this.elementRef.nativeElement.querySelectorAll('.invalid-input');
		invalidInputs.forEach((item) => {
			item.classList.remove('invalid-input');
		});

		this.siteService.saveSiteUtilizationSettings(this.siteId, this.settingType, this.truckUtilizationSettings, this.selectedDays).subscribe((res: any) => {
			if (res && res?.length) {
				return this.notificationService.setMessage('globalSuccessMsg');
			} else {
				return this.notificationService.setMessage('globalErrMsg');
			}
		});
	}

	validateInputs() {
		this.disableButton = false;
		for (const field in this.truckUtilizationSettings) {
			const newValue = this.truckUtilizationSettings[field];
			const ele = this.elementRef.nativeElement.querySelectorAll(`[name=${field}]`);
			this.render.removeClass(ele[0], 'invalid-input');

			if (newValue == null || newValue == undefined || isNaN(newValue)) {
				this.handleInvalidInputs(field);
				continue;
			}

			switch(field) {
				case 'min_daily_truck_operating_minutes':
					if (newValue < 0 || newValue % 15 != 0)
						this.handleInvalidInputs(field);
				break;
				case 'min_truck_utilization':
					if (newValue < 0 || newValue > 100)
						this.handleInvalidInputs(field);
				break;
				case 'min_truck_energy_utilization':
					if (newValue < 0 || newValue > 100)
						this.handleInvalidInputs(field);
				break;
				case 'geofence_distance':
				case 'deep_in_use_end_voltage_limit':
				case 'num_of_deep_in_use_cycles':
				case 'low_in_use_end_voltage_limit':
				case 'num_of_low_in_use_cycles':
					if (newValue < 1)
						this.handleInvalidInputs(field);
				break;
				case 'shift_schedule':
					if (!Object.values(shiftScheduleOptions).includes(newValue))
						this.handleInvalidInputs(field);
					break;
				default:
					this.disableButton = true;
				break;
			}
		}
	}

	onCheckboxChange(value: number, checked: boolean) {
		this.selectedDays = checked ? [...this.selectedDays, value] : this.selectedDays.filter(day => day !== value);
		this.disableButton = this.selectedDays.length == 0 ? true : false;
	}

	isChecked(dayId: number) {
		return this.selectedDays.includes(dayId);
	}

	handleInvalidInputs(field: string): boolean {
		const form = this.elementRef.nativeElement;
		const ele = form.querySelectorAll(`[name=${field}]`);
		if(ele && ele[0])
			this.render.addClass(ele[0], 'invalid-input');
		return this.disableButton = true;
	}

	ngOnDestroy() {
		this.subSite.unsubscribe();
	}
}
